import React, { useState } from "react";
import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";
import { PageHead } from "../components/site/Section";
import { Icon } from "../components/site/Icons";
import { CONTACT_EMAIL, SUPPORT_EMAIL, PRIVACY_EMAIL } from "../data/content";

const channels = [
  { icon: "mail", title: "Get in touch", email: CONTACT_EMAIL, body: "Questions before you start, or you run more than one venue and want to talk it through." },
  { icon: "help", title: "Support", email: SUPPORT_EMAIL, body: "Already using Barlo? Tell us your venue name and what you were doing when it went wrong. Starter: reply within one working day. Pro: the same working day." },
  { icon: "shield", title: "Privacy", email: PRIVACY_EMAIL, body: "Questions about your data, or a request to see or delete it." },
];

function CopyButton({ text }) {
  const [note, setNote] = useState("");
  const copy = () => {
    try {
      navigator.clipboard.writeText(text).then(() => setNote("Copied"), () => setNote(text));
    } catch (e) {
      setNote(text);
    }
  };
  return (
    <>
      <button className="btn btn-ghost copy" type="button" onClick={copy}>Copy address</button>
      <span className="copied" aria-live="polite">{note}</span>
    </>
  );
}

export default function Contact() {
  return (
    <div className="App" data-testid="contact-page">
      <Navbar />
      <main>
        <PageHead kicker="Contact Barlo" title="Talk to us" lede="Email is the quickest way to reach us. We reply Monday to Friday, UK hours." />
        <section style={{ paddingTop: 0 }}>
          <div className="wrap">
            <div className="contact-grid">
              {channels.map((c) => (
                <article className="fcard" key={c.email}>
                  <span className="ficon"><Icon name={c.icon} /></span>
                  <h2 className="card-h">{c.title}</h2>
                  <p>{c.body}</p>
                  <a className="email" href={`mailto:${c.email}`}>{c.email}</a>
                  <CopyButton text={c.email} />
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
